<div class="min-h-screen bg-white flex items-center justify-center p-4">
  <div class="relative z-10 w-full max-w-md">
    <div class="bg-white rounded-xl shadow-lg border border-gray-200 p-8 md:p-10 space-y-8 animate-fade-in-up">
      <div class="text-center space-y-2">
        <div class="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-xl shadow-sm mb-4">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
          </svg>
        </div>
        <h1 class="text-3xl font-bold text-gray-900 tracking-tight">Connexion</h1>
        <p class="text-gray-500 text-sm">Accédez à votre espace personnel</p>
      </div>

      <form (ngSubmit)="connexion()" class="space-y-6">
        <div class="space-y-2 animate-fade-in-up" style="animation-delay: 0.1s">
          <label for="identifiant" class="block text-sm font-semibold text-gray-700 mb-2">
            Identifiant
            <span class="text-red-500">*</span>
          </label>
          <div class="relative group">
            <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <svg class="w-5 h-5 text-gray-400 group-focus-within:text-blue-500 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
            </div>
            <input 
              type="text" 
              id="identifiant"
              name="identifiant"
              [(ngModel)]="login.identifiant"
              placeholder="Entrez votre identifiant"
              required
              class="w-full pl-12 pr-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-300"
            />
          </div>
        </div>

        <div class="space-y-2 animate-fade-in-up" style="animation-delay: 0.2s">
          <label for="password" class="block text-sm font-semibold text-gray-700 mb-2">
            Mot de passe
            <span class="text-red-500">*</span>
          </label>
          <div class="relative group">
            <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <svg class="w-5 h-5 text-gray-400 group-focus-within:text-blue-500 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
              </svg>
            </div>
            <input 
              type="password" 
              id="password"
              name="password"
              [(ngModel)]="login.password"
              placeholder="Entrez votre mot de passe"
              required
              class="w-full pl-12 pr-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-300"
            />
          </div>
        </div>

        <div 
          *ngIf="error !== ''" 
          class="flex items-center gap-3 p-4 bg-red-50 border-l-4 border-red-500 rounded-xl animate-shake"
        >
          <svg class="w-5 h-5 text-red-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <p class="text-sm font-medium text-red-800">{{ error }}</p>
        </div>

        <button 
          type="submit" 
          [disabled]="!tentativeConnexion"
          class="w-full py-3.5 px-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl shadow-md hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 animate-fade-in-up"
          style="animation-delay: 0.3s"
        >
          <span class="flex items-center justify-center gap-2">
            <svg 
              *ngIf="!tentativeConnexion"
              class="animate-spin h-5 w-5 text-white" 
              xmlns="http://www.w3.org/2000/svg" 
              fill="none" 
              viewBox="0 0 24 24"
            >
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <svg 
              *ngIf="tentativeConnexion"
              class="w-5 h-5" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
            </svg>
            <span>{{ tentativeConnexion ? 'Se connecter' : 'Connexion...' }}</span>
          </span>
        </button>
      </form>

      <div class="pt-6 border-t border-gray-200 animate-fade-in-up" style="animation-delay: 0.4s">
        <p class="text-center text-xs text-gray-500">
          © 2025 NUMEROVIP. Tous droits réservés.
        </p>
      </div>
    </div>
  </div>
</div>
